import dayjs from 'dayjs';

type TimeUnitType = 'seconds' | 'milliseconds';

export const timeTrans = (time: string) => {
  if (!time) return '--';
  const date = new Date(new Date(time).getTime() + 8 * 3600 * 1000).toJSON();
  return date.substring(0, 19).replace('T', ' ');
};

/**
 * -> 时间戳，毫秒
 * @param date
 * @returns
 */
export function parseDate(date?: string | number, unit: TimeUnitType = 'seconds'): string {
  if (!date) {
    return date as string;
  }
  const dateObj = dayjs(date);
  return `${unit === 'seconds' ? dateObj.unix() : dateObj.valueOf()}`;
}

/**
 * 时间戳，格式化为时间
 * @param dateStr
 * @param formatStr
 * @returns
 */
export function asyncDate(dateStr?: string | number, formatStr = 'YYYY-MM-DD HH:mm:ss') {
  if (!dateStr) {
    return '';
  }
  const dateTime = `${dateStr}`.length > 12 ? +dateStr : +dateStr * 1000;
  return dayjs(dateTime).format(formatStr);
}

/**
 * 时间戳转换为时分秒
 * @param timetamp
 * @param unit
 * @returns
 */
export const parseMs = (timetamp: number, unit: TimeUnitType = 'milliseconds') => {
  const unitTime = unit === 'seconds' ? 1 : 1000;
  const seconds = timetamp / unitTime;
  return {
    days: Math.floor(seconds / 86400),
    hours: Math.floor(seconds / 3600) % 24,
    minutes: Math.floor(seconds / 60) % 60,
    seconds: Math.floor(seconds) % 60,
  };
};

/**
 * 时间戳转换为时分秒-格式化字符串
 * @param text
 * @returns
 */
export const timetampToTime = (text?: number | string, unit: TimeUnitType = 'milliseconds'): string => {
  if (!text && text !== 0) {
    return '';
  }
  const time = parseMs(+text, unit);
  const minute = `${time.minutes}`.padStart(2, '0');
  const second = `${time.seconds}`.padStart(2, '0');
  return `${time.hours}:${minute.padStart(2, '0')}:${second}`;
};
